import React from 'react';
import { logoBuilderContent } from '../rich-content/logo-builder-complete-content';
import { AutomaticPageBuilder } from '../page-sections/automatic-page-builder';

const LogoBuilderDetailPage = () => {
  return <AutomaticPageBuilder content={logoBuilderContent} />;
};

export default LogoBuilderDetailPage;
